'use client';

import { SubscriptionModalProvider as ModalProvider } from '@/layers/presentation/components/ui/SubscriptionPrompt';
import React from 'react';

export function SubscriptionModalProvider({ children }: { children: React.ReactNode }) {
  return <ModalProvider>{children}</ModalProvider>;
}
